import { getData, putData } from "../lib/fetchApi";
import { CABINET_SETTINGS_URL } from "../constants/urls";

const cabinetSettingsService = {
    getSettings: () => getData({ url: CABINET_SETTINGS_URL }),
    updateSettings: (data) => putData({ url: CABINET_SETTINGS_URL, data }),
};

export default cabinetSettingsService;
